<template>

    <div class="user-menu" v-if="info && info.User && info.User.TermsConfirmed">
        <div :class="['page-menu-content-1', { 'collapse': collapsed }]"
             v-if="info.User.SalesPlan != null || info.User.SalesFact != null" @mouseenter="onSpanEnter" @mouseleave="onSpanLeave">
            <div class="sidebar-search-wrapper">
                <div class="sidebar-search" style="text-align:center">
                    <span v-html="userPlanFactData.Display"></span>
                </div>
            </div>
        </div>
        <div class="page-menu-content-1" :class="{ 'collapse': collapsed }"
             v-if="hasClaims(info.User.DynamicRole, claimEnums.reportAdd) && addReportLinkName">
            <div class="sidebar-search-wrapper">
                <div class="sidebar-search">
                    <router-link :to="'/reports/' + (info.ReportType === 2 ? 'fns/' : '') + '0'" class="btn btn-primary btn-with-img">
                        <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink">
                            <use xlink:href="/Content/dist/images.svg#Plus"></use>
                        </svg>
                        <span class="btn-text">{{addReportLinkName}}</span>
                    </router-link>
                </div>
            </div>
        </div>
        <div class="page-menu-content-2" :class="{ 'collapse': collapsed }">
            <div :class="['menu-item', { 'active': $route.path.startsWith('/profile') }]">
                <router-link to="/profile" disabled>
                    <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:style="{fill: menuColor}">
                        <use xlink:href="/Content/dist/images.svg#MenuProfile"></use>
                    </svg>
                    <span>Профиль</span>
                </router-link>
            </div>
            <div :class="['menu-item start', { 'active': $route.path.startsWith('/projects') }]"
                 v-if="hasClaims(info.User.DynamicRole, claimEnums.projectPage) || info.User.MainRole === 'administrators'">
                <router-link to="/projects" disabled>
                    <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:style="{fill: menuColor}">
                        <use xlink:href="/Content/dist/images.svg#MenuProject"></use>
                    </svg>
                    <!--<img src="../../../img/icon-home.png" alt="" />-->
                    <span>Проекты</span>
                </router-link>
            </div>

            <div v-for="page of pagesOrdered" :class="['menu-item', { 'active': page.active, 'comback': page.img == '/Content/dist/images.svg?v3#MenuBonus' }]" v-if="page.hasClaims">
                <router-link :to="page.Path">
                    <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:style="{stroke: menuColor }"
                         v-if="page.img == '/Content/dist/images.svg?v3#MenuBonus'">
                        <use :xlink:href="page.img"></use>
                    </svg>
                    <svg class="svg-icon" xmlns="http://www.w3.org/2000/svg" xmlns:xlink="http://www.w3.org/1999/xlink" v-bind:style="{fill: menuColor }"
                         v-else>
                        <use :xlink:href="page.img"></use>
                    </svg>
                    <!--<img :src="page.img" v-if="page.img != null" alt="" />-->
                    <span>{{page.Name}}</span>
                    <span v-if="page.span != null" :class="['menu-item-info', page.span.css]">{{ page.span.value }}</span>
                    <span v-if="page.Path === '/cart' && cartItemsCount > 0"> ({{cartItemsCount}})</span>
                </router-link>
            </div>

        </div>

        <transition name="fade">
            <div class="tooltip" ref="spanTooltip" v-show="showSpanDetails">
                <div class="tooltip-body" v-html="userPlanFactData.Tooltip"></div>
            </div>
        </transition>
    </div>
</template>

<script>
    import authMixin from '../../helpers/auth-mixin'
    import '../../../img/image_svg.svg'
    import _ from "lodash";

    export default {
        name: "side-menu",

        props: ['collapsed', 'info', 'cartItemsCount', 'menuColor'],

        mixins: [authMixin],

        data() {
            return {
                pages: [],
                addReportLinkName: null,
                showSpanDetails: false
            }
        },

        watch: {
            '$route': function () {
                for (let page of this.pages) {
                    switch (page.Path) {
                        case '/':
                            page.active = this.$route.name === 'news' || this.$route.name === 'newsDetails' || this.$route.name === 'newsEdit';
                            break;
                        case '/materials':
                            page.active = this.$route.path.startsWith('/materials');
                            break;
                        default:
                            page.active = this.$route.name === page.Path.replace('/', '');
                            break;
                    }
                }
            },
            'info': function () {
                this.setPages(); 
            }
        },

        computed: {
            pagesOrdered: function () {
                return _.orderBy(this.pages, 'PageOrder');
            },

            userPlanFactData(){
                let display = [], tooltip = [], donePercent = null;
                if(this.info.User.SalesPlan != null){
                    let salesPlan = this.formatInt(this.info.User.SalesPlan.toFixed(0));
                    display.push(salesPlan + ' шт.');// (salesPlan < 1000 ? ' шт.' : ' руб.'));
                    tooltip.push('План: ' + salesPlan + ' шт.');// (salesPlan < 1000 ? ' шт.' : ' руб.'));
                }
                if(this.info.User.SalesFact != null){
                    let salesFact = this.formatInt(this.info.User.SalesFact.toFixed(0));
                    display.push(salesFact + ' шт.');// (salesFact < 1000 ? ' шт.' : ' руб.'));
                    tooltip.push('Продано: ' + salesFact + ' шт.');// (salesFact < 1000 ? ' шт.' : ' руб.'))
                }
                if(this.info.User.SalesPlan > 0 && this.info.User.SalesFact != null){
                    donePercent = (this.info.User.SalesFact / this.info.User.SalesPlan) * 100;
                    tooltip.push('Выполнено: ' + donePercent.toFixed(2) + '%');
                }
                display.reverse();
                return {
                    Display: display.join(' / ') + (donePercent != null ? ' (' + donePercent.toFixed(0) + '%)' : ''),
                    Tooltip: tooltip.join(',<br>')
                }
            }
        },

        methods:{
            onSpanEnter: _.debounce(function () {
                this.showSpanDetails = true;
            }, 200),

            onSpanLeave(){
                this.showSpanDetails = false;
            },

            refreshMenuData(){
                // todo:
            },

            setPages() {
                let url = '/Content/dist/images.svg?v3#Menu';
                this.pages = [
                    {
                        Path: '/',
                        Name: 'Новости',
                        PageOrder: 1,
                        active: this.$route.name === 'news' || this.$route.name === 'newsDetails' || this.$route.name === 'newsEdit',
                        hasClaims: (this.hasClaims(this.info.User.DynamicRole, this.claimEnums.newsPage) && !this.info.User.IsDisabled) || this.info.User.MainRole === 'administrators',
                        img: url + 'News',
                        span: this.info.User.NotReadNews > 0 ? { css: '', value: this.info.User.NotReadNews} : null
                    },
                    {
                        Path: '/materials',
                        Name: 'Материалы',
                        PageOrder: 2,
                        active: this.$route.path.startsWith('/materials'),
                        hasClaims: (this.hasClaims(this.info.User.DynamicRole, this.claimEnums.materialsPage) && !this.info.User.IsDisabled) || this.info.User.MainRole === 'administrators',
                        img: url + 'Material',
                        span: this.info.User.NotLearnedMaterials > 0 ? { css: '', value: this.info.User.NotLearnedMaterials} : null
                    },
                    {
                        Path: '/reports',
                        Name: 'Отчеты',
                        PageOrder: 3,
                        active: this.$route.name === 'reports',
                        hasClaims: (this.hasClaims(this.info.User.DynamicRole, this.claimEnums.reportsPage) && !this.info.User.IsDisabled) || this.info.User.MainRole === 'administrators',
                        img: url + 'Doc',
                        span: this.info.User.ReportsOnEdition > 0 ? { css: '', value: this.info.User.ReportsOnEdition} : null
                    },
                    {
                        Path: '/rating',
                        Name: 'Рейтинг',
                        PageOrder: 4,
                        active: this.$route.name === 'rating',
                        hasClaims: (this.hasClaims(this.info.User.DynamicRole, this.claimEnums.ratingPage) && !this.info.User.IsDisabled) || this.info.User.MainRole === 'administrators',
                        img: url + 'Rating'
                    },
                    {
                        Path: '/spend-bonuses',
                        Name: 'Потратить бонусы',
                        PageOrder: 5,
                        active: this.$route.name === 'spend-bonuses' || this.$route.path.startsWith('/rewards'),
                        hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.spendBonusesPage) || this.info.User.MainRole === 'administrators',
                        img: url + 'Bonus',
                        span: this.info.User.ActiveBalanceWithOrders > 0 ? { css: '', value: this.info.User.ActiveBalanceWithOrders} : null
                    },
                    {
                        Path: '/analytics',
                        Name: 'Аналитика',
                        PageOrder: 6,
                        active: this.$route.name === 'analytics',
                        hasClaims: (this.hasClaims(this.info.User.DynamicRole, this.claimEnums.analyticsPage) && !this.info.User.IsDisabled) || this.info.User.MainRole === 'administrators',
                        img: url + 'Analit'
                    },
                    {
                        Path: '/sku',
                        Name: 'SKU',
                        PageOrder: 7,
                        active: this.$route.path.startsWith('/sku'),
                        hasClaims: (this.hasClaims(this.info.User.DynamicRole, this.claimEnums.skuPage) && !this.info.User.IsDisabled) || this.info.User.MainRole === 'administrators',
                        img: url + 'Sku'
                    },
                    {
                        Path: '/motivation',
                        Name: 'Программа мотивации',
                        PageOrder: 8,
                        active: this.$route.name === 'motivation',
                        hasClaims: (this.hasClaims(this.info.User.DynamicRole, this.claimEnums.motivationPage) && !this.info.User.IsDisabled) || this.info.User.MainRole === 'administrators',
                        img: url + 'Help'
                    },
                    {
                        Path: '/faq',
                        Name: 'FAQ',
                        PageOrder: 9,
                        active: this.$route.name === 'faqPage',
                        hasClaims: (this.hasClaims(this.info.User.DynamicRole, this.claimEnums.faqPage)&& !this.info.User.IsDisabled) || this.info.User.MainRole === 'administrators',
                        img: url + 'Faq'
                    },
                    {
                        Path: '/orders',
                        Name: 'Заказы',
                        PageOrder: 10,
                        active: this.$route.name === 'orders',
                        hasClaims: (this.hasClaims(this.info.User.DynamicRole, this.claimEnums.ordersPage) && !this.info.User.IsDisabled) || this.info.User.MainRole === 'administrators',
                        img: url + 'Cabinet',
                        span: this.info.User.OrdersToProcess > 0 ? { css: '', value: this.info.User.OrdersToProcess} : null
                    },
                    {
                        Path: '/cart',
                        Name: 'Мои заказы',
                        PageOrder: 11,
                        active: this.$route.name === 'cart',
                        hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.bonusSpend) && this.info.User.ProjectId !== 7,
                        img: url + 'Cabinet'
                    },
                    {
                        Path: '/sender',
                        Name: 'Рассылка',
                        PageOrder: 12,
                        active: this.$route.name === 'sender',
                        hasClaims: this.hasClaims(this.info.User.DynamicRole, this.claimEnums.senderPage) || this.info.User.MainRole === 'administrators',
                        img: url + 'Mail'
                    },
                    {
                        Path: '/tasks',
                        Name: 'Задания',
                        PageOrder: 13,
                        active: this.$route.path.startsWith('/tasks'),
                        hasClaims: (this.hasClaims(this.info.User.DynamicRole, this.claimEnums.tasksPage) && !this.info.User.IsDisabled) || this.info.User.MainRole === 'administrators',
                        img: url + 'Tasks'
                    },
                    {
                        Path: '/my-progress',
                        Name: 'Мои достижения',
                        PageOrder: 14,
                        active: this.$route.path.startsWith('/my-progress'),
                        hasClaims: (this.hasClaims(this.info.User.DynamicRole, this.claimEnums.myProgressPage) && !this.info.User.IsDisabled) || this.info.User.MainRole === 'administrators',
                        img: url + 'MyProgress'
                    }];


                for(let page of this.pages){
                    let projectPage = this.info.Pages.find(x => x.Path === page.Path);
                    if(projectPage){
                        page.PageOrder = projectPage.PageOrder;
                        if(projectPage.Name){
                            page.Name = projectPage.Name;
                        }
                    }
                }
                if(this.hasClaims(this.info.User.DynamicRole, this.claimEnums.reportAdd) && !this.info.User.IsDisabled) {
                    let reportAddPage = this.info.Pages.find(x => x.Path === '/reports/0');
                    if (reportAddPage) {
                        if (reportAddPage.Name) {
                            this.addReportLinkName = reportAddPage.Name;
                        } else {
                            this.addReportLinkName = 'Добавить отчёт';
                        }
                    }
                }
            }
        },

        mounted(){
            let vm=this;
            vm.setPages();
            vm.$nextTick(()=>{
                document.querySelector('.body-panel').appendChild(vm.$refs['spanTooltip']);
            });
        }
    }
</script>

<style scoped>
    .fade-enter-active, .fade-leave-active {
        transition: opacity 0.5s;
    }
    .fade-enter, .fade-leave-to {
        opacity: 0;
    }
    .tooltip{left:105px; top: 195px; bottom: auto;}
</style>



// WEBPACK FOOTER //
// Content/src/views/shared/SideMenu.vue